import { render, staticRenderFns } from "./confirm-suppliers-email.vue?vue&type=template&id=4ccc91a4"
import script from "./confirm-suppliers-email.vue?vue&type=script&lang=js"
export * from "./confirm-suppliers-email.vue?vue&type=script&lang=js"
import style0 from "./confirm-suppliers-email.vue?vue&type=style&index=0&id=4ccc91a4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccc91a4')) {
      api.createRecord('4ccc91a4', component.options)
    } else {
      api.reload('4ccc91a4', component.options)
    }
    module.hot.accept("./confirm-suppliers-email.vue?vue&type=template&id=4ccc91a4", function () {
      api.rerender('4ccc91a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/confirm-suppliers-email.vue"
export default component.exports